import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCListingsManager(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 502.295 342.865">
            <g id="Listings_Manager" transform="translate(-3.14 -86.985)">
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="9.93"
                    cy="9.93"
                    r="9.93"
                    transform="translate(467.94 282.9)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="6.38"
                    cy="6.38"
                    r="6.38"
                    transform="translate(24.58 297.39)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="9.11"
                    cy="9.11"
                    r="9.11"
                    transform="translate(4.14 250.95)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M30.07,95.31H23V88.24a.87.87,0,0,0-.88-.88h0a.9.9,0,0,0-.9.88v7.07H14.14a.89.89,0,1,0,0,1.78h7.07v7.08a.9.9,0,0,0,.9.88.87.87,0,0,0,.88-.88h0V97.09h7.08a.88.88,0,0,0,.89-.88.89.89,0,0,0-.89-.9Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M474.33,102.78H468.5V97a.73.73,0,0,0-.73-.72h0A.74.74,0,0,0,467,97v5.83h-5.82a.74.74,0,0,0,0,1.47H467v5.83a.74.74,0,0,0,.74.73.73.73,0,0,0,.73-.73h0V104.3h5.83a.74.74,0,0,0,0-1.47Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M504.06,146.68h-8.19v-8.17a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v8.17h-8.16a1,1,0,0,0,0,2h8.16v8.18a1,1,0,0,0,2,0h0v-8.18h8.19a1,1,0,0,0,0-2Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="242.37"
                    cy="68.41"
                    rx="242.37"
                    ry="68.41"
                    transform="translate(16.71 293.03)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M58.15,117.19V305.43A28.55,28.55,0,0,0,86,334c68.75,1.78,269.43,6.07,334.88,5.11a21,21,0,0,0,20.68-20.41c1.26-43.73,3.31-148.89-4.27-197.7a21.64,21.64,0,0,0-20.68-18.31C359,100.82,143.86,95,78.44,96.44A20.75,20.75,0,0,0,58.15,117.19Z"
                    fill="#707272"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M70,116.78V302.6a16.92,16.92,0,0,0,16.3,17.19l325.17,4.69c9,.14,16.31-7.36,16.34-16.67l.61-184.17a12,12,0,0,0-11.49-12.27L83,103.52a13,13,0,0,0-13,13.26Z"
                    fill="#fff"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M401.66,316.76,89.92,313.17c-6.74.16-12.24-7-12.19-15.9l.79-157.95c.69-16.76,8.12-24.28,14.75-24.25l308.51,10c6.63,0,12,7.16,11.92,15.91L413,289.82C412.91,298.43,408.19,316.6,401.66,316.76Z"
                    fill="#e4e3e3"
                    opacity="0.31"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M303.44,147.72l15.12.07a.89.89,0,0,1,.93.82l.12,6.28a.9.9,0,0,0,1.09.81l27.65-4.21h.16l19,.1h.14l21.48-2.78a1,1,0,0,1,.73.18l4.72,3.46a.77.77,0,0,1,.15,1.16l-5.83,6.7a.73.73,0,0,0-.18.67l2.53,11a.68.68,0,0,1-.07.52l-9,17a1,1,0,0,1-1.58.16l-5.27-6a.77.77,0,0,1-.18-.69l2.28-9.71c.19-.83-1-1.36-1.61-.73l-5.64,5.52a1,1,0,0,1-.39.23l-6.52,2a.94.94,0,0,0-.52.39L359.52,186a.82.82,0,0,0,.69,1.22l7.34.93a.87.87,0,0,1,.8.78l.93,17.08a.83.83,0,0,1-.35.69L362,211.61a.77.77,0,0,0-.28.95l1.58,3.59a.84.84,0,0,1-.8,1.14l-1.89.12a1,1,0,0,1-.81-.33l-5.36-6.31a1,1,0,0,0-1.65.27l-.57,1.75a.76.76,0,0,0,.06.61l5.23,9.07a.77.77,0,0,1-.16,1l-9.29,8.46a1.91,1.91,0,0,1-1.73.41l-1.63-.42a1.77,1.77,0,0,0-2.14,1h0a1.39,1.39,0,0,0,.25,1.38l4.74,5.75a1.44,1.44,0,0,1-.2,2.05l-2.63,2.21a1.9,1.9,0,0,1-2.43,0L327.7,231.4a1.91,1.91,0,0,0-2.46,0l-7.86,7a1.54,1.54,0,0,0-.47.75l-.65,2.55a1.83,1.83,0,0,1-3.09.59L300.92,228a2.19,2.19,0,0,0-1.36-.72l-8.47-1.13a2,2,0,0,1-.69-.21l-3.5-1.7c-1-.47-2.06.42-1.61,1.32l.8,1.58a2.09,2.09,0,0,0,1.58,1.08l5.9.82a2.07,2.07,0,0,1,1.64,1.2l.29.69a1.77,1.77,0,0,1-.84,2.22l-13.08,7.38a1.24,1.24,0,0,1-1.67-.43l-7.81-14.7a1.22,1.22,0,0,0-1.44-.53h0a1,1,0,0,0-.65,1.41l6.64,12.45a5.75,5.75,0,0,0,6.3,2.65l1.1-.24a2,2,0,0,1,2.5,2.4L284.87,248a1.92,1.92,0,0,1-.68.87l-6,4.26a4.71,4.71,0,0,0-2.07,4.09l.31,5a4.67,4.67,0,0,1-1.83,3.92l-2.42,1.92a3.63,3.63,0,0,0-1.42,3.3l.12,1a3.65,3.65,0,0,1-1.39,3.27l-9.18,7.44a4.74,4.74,0,0,1-3.86.91l-1.78-.34a4.21,4.21,0,0,1-3.19-2.57l-5.06-13.58a3.59,3.59,0,0,1,1.24-4.11h0a3.59,3.59,0,0,0,1.25-4.06l-2.79-7.88a6.39,6.39,0,0,0-7.32-3.75l-7.23,1.44a2,2,0,0,1-1.68-.39l-10.19-8.12a1.62,1.62,0,0,1-.63-1.26l.05-9.46A10.05,10.05,0,0,1,222,223l1.25-1.3a14.64,14.64,0,0,1,9.16-4.3l7.33-.71,4.95-.54a1.89,1.89,0,0,1,2.09,1.33l.33,1.44a1.76,1.76,0,0,0,1,1.17l7.09,3,.88-2.89,12.95,1.35.21-3.33a1.06,1.06,0,0,0-.92-1.07l-5.53-1-2.33-4.5-4.2-.9,1.86,5.5-3.31-3.61-4.6-4.23a2.06,2.06,0,0,0-2.48-.19h0a1.57,1.57,0,0,0-.25,2.52l4.28,4h-2.53a2,2,0,0,1-1.25-.43l-5-4a2.06,2.06,0,0,0-2.65.12l-4.13,4a2,2,0,0,1-1.07.53l-3.31.51a1.89,1.89,0,0,1-2.19-1.35l-.69-3.31a1.77,1.77,0,0,1,2-2l2.4.18a1.73,1.73,0,0,0,1.93-2.23L234.22,204a1.6,1.6,0,0,1,.73-1.95l8.28-5,12.51-.84,2.43-7.2-3.2-1,1.17-6.39-2.41.23-3,5.34.2,5.93-3.69,1.22-1.95-4.52-3.09,1.76-1.63-5.89a.17.17,0,0,1,0-.15L253,170.35l16.38,4.4.17,2.61-4.25,1.69-.25,4,6.94-4.93,9.87-4.81.22-3.17h4.46a1,1,0,0,1,.5.13l1.66.95a.912.912,0,0,0,1.39-1l-1.84-4.82a.76.76,0,0,1,.12-.75l1.61-2a1,1,0,0,1,.86-.35l4.06.39a1.06,1.06,0,0,1,.47.17l.51.36c.78.53,1.83-.21,1.43-1h0a.83.83,0,0,1,.67-1.16l1.9-.34a.81.81,0,0,0,.35-1.5l-1-.63a.78.78,0,0,1-.08-1.3l4.79-3.78a1,1,0,0,1,.29-.15l4-1.35a.8.8,0,0,0,.5-1.16l-.37-.66a1,1,0,0,0-1.08-.42l-3.75.87a.91.91,0,0,1-1.17-.86l.08-1.3a.89.89,0,0,1,1-.76Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M370.16,261.48l-8.7,2.82a1.69,1.69,0,0,0-.92.69L358,269a1.69,1.69,0,0,1-1.06.73l-7.81,1.87a1.58,1.58,0,0,0-1.27,1.69l1.43,10.07a1.36,1.36,0,0,1-.15.84L348,286.45a1.54,1.54,0,0,0,1.22,2.17l1.43.27a1.88,1.88,0,0,0,1.05-.09l12.6-4.85a1.89,1.89,0,0,1,2.16.58l2.91,4a1.26,1.26,0,0,0,.3.31l4.54,3.61a1.89,1.89,0,0,0,1.37.39l7.34-.8a1.63,1.63,0,0,0,1.53-1.49l.12-3.15a1.39,1.39,0,0,1,.32-.84l4.52-5.68a1.48,1.48,0,0,0,.33-.89V275.6a1.52,1.52,0,0,0-.52-1.12l-6.06-5.3a1.45,1.45,0,0,1-.45-.67l-1.11-3.35a1.82,1.82,0,0,0-3.34,0l-.4,1.16a1.83,1.83,0,0,1-2.72.77l-1.38-.94a1.45,1.45,0,0,1-.5-1.92h0a1.46,1.46,0,0,0-.62-2l-.94-.53a1.94,1.94,0,0,0-1.54-.22Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M368,251.66l-.2.56a1.48,1.48,0,0,0,.59,1.67l5,3.55a1.941,1.941,0,0,0,.74.31l9.46,1.71a1.532,1.532,0,0,1,.29.07l1.23.42c1.54.53,3-1,2.12-2.24l-.49-.74a1.76,1.76,0,0,0-.84-.65l-15.57-5.64a1.79,1.79,0,0,0-2.33.98Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M352.67,245.44l-3.86,3.8a1.44,1.44,0,0,0-.33,1.61l2.07,4.65a1.79,1.79,0,0,0,2,.93l3.19-.7a1.68,1.68,0,0,0,1.25-1L358.3,251a1.4,1.4,0,0,0-.17-1.24l-2.67-4a1.86,1.86,0,0,0-2.79-.32Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M336.54,246.05l7.21,8.15.07.08,4.45,4.42a1.8,1.8,0,0,0,1.16.51l8.55.59-.05.14a1.74,1.74,0,0,1-1.59,1.08l-11.94.47a1.81,1.81,0,0,1-1.53-.7l-9.38-12.74a1.43,1.43,0,0,1,.27-2l.23-.19a1.89,1.89,0,0,1,2.55.19Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M163.16,238.23,161,241a1.37,1.37,0,0,1-1.35.47l-4-.83a1.19,1.19,0,0,1-1-1.12V237a1.22,1.22,0,0,0-1.23-1.16l-2.35-.1a1.16,1.16,0,0,1-1.08-1.7l2.54-4.17-3.94-1.18s-3,4.28-3.58,4.3-4.48-5.43-4.48-5.43l4.91-5.52,7.56-.16,3.59,4.65,2.29-7.5,8.43-5.64L183.9,203a.8.8,0,0,0,.28-.3l3.12-6a.7.7,0,0,0-.12-.8l-4.92-5.17a.7.7,0,0,1-.19-.42l-.29-2.81a.87.87,0,0,0-1.57-.3h0a.89.89,0,0,1-1.39.1l-3.32-3.75a2,2,0,0,0-2.84,0l-4.24,4.5a1.62,1.62,0,0,0-.28.42l-1.86,4a1.93,1.93,0,0,1-3.35.07l-.1-.19a1.77,1.77,0,0,0-.86-.78c-1.82-.77-7.26-3.19-7.29-4.17s3.67-6.65,4.67-8.16a1.77,1.77,0,0,1,.68-.59l7.09-3.51h.09l6.69-2.89a1.62,1.62,0,0,0,1-1.55l-.09-1.59a1.81,1.81,0,0,0-2.23-1.51l-3.22.64a1.86,1.86,0,0,0-.84.39l-1.43,1.17a2,2,0,0,1-2.86-.43l-2-3.35a2,2,0,0,0-2.66-.58l-2.7,1.56a2,2,0,0,1-1.57.22l-9.24-2.49a1.85,1.85,0,0,1-.52-.22l-7.91-4.94a2,2,0,0,0-1.51-.24l-6.23,1.43a2,2,0,0,1-1.67-.36L117.51,152a2,2,0,0,0-1.69-.36c-2,.47-6.7,1.56-8.65,1.78s-4.11,2.56-5,3.56a.81.81,0,0,0-.07.94l.9,1.52a.87.87,0,0,1-.72,1.28l-3.34.47a.87.87,0,0,0-.69,1.32l.78,1.17a.74.74,0,0,1,.12.61l-.61,2.91a1,1,0,0,1-1.21.69l-3.2-.69a1,1,0,0,0-1.22.9l.28,4.49a.78.78,0,0,0,.21.49l2.66,3.06a.82.82,0,0,1-.27,1.29c-2.62,1.41-9.74,5.24-9,4.79.86-.54,8.67.15,8.74-1.05s5.25-2.32,5.61-2.74,2.24-2.84,3.2-4.08a1.06,1.06,0,0,1,1.32-.25l7.88,4.2a1.61,1.61,0,0,1,.89,1.25l.85,8.6a1.56,1.56,0,0,0,.25.68l3.36,5.09,3.87,6.45a1.48,1.48,0,0,1,.11,1.31l-2.13,5.4a14.08,14.08,0,0,0,1,12.38c1.82,3.12,3.68,6.35,3.79,6.65a2.41,2.41,0,0,0,.31.5,15.71,15.71,0,0,0,6.49,5.11l12.23,5.4.16.08,9,5.47a1.08,1.08,0,0,1,.24.18l1.5,1.5a1.43,1.43,0,0,0,1.18.37h0a1.2,1.2,0,0,1,1.4,1.6l-2.4,4.82a1.05,1.05,0,0,0-.09.63l1.5,9.42a1.11,1.11,0,0,0,.39.67l6.41,5.44a1.09,1.09,0,0,1,.37.6l2.23,9.46a1,1,0,0,1,0,.17l1.73,26.08a1.15,1.15,0,0,0,.53.86l6,3.9a1.41,1.41,0,0,0,.85.22l2.07-.12a1.13,1.13,0,0,0,.82-2l-2-1.76a1.06,1.06,0,0,1-.38-.75l-.16-2.47v-4.61a1.488,1.488,0,0,1,0-.21l.75-3.48v-.06l.36-2.43a1.18,1.18,0,0,1,.78-.91l5.1-1.94a1.11,1.11,0,0,0,.68-1.52L183,285a1.13,1.13,0,0,1,.87-1.58l2-.44a1.36,1.36,0,0,0,.78-.51l4.15-5.86a1,1,0,0,0,0-1.27l-.09-.11a1.12,1.12,0,0,1,.8-1.79l2.32-.41a1.28,1.28,0,0,0,1-.79l3.39-9.66a1.06,1.06,0,0,1,.26-.41l4.81-4.94a1.08,1.08,0,0,0-.23-1.7l-6.6-4.15a1.47,1.47,0,0,0-.8-.21l-4.74.18a1.35,1.35,0,0,1-.86-.24l-2.85-2a1.11,1.11,0,0,1-.49-.87l-.08-3.11a1.17,1.17,0,0,0-.92-1.08l-5.79-1.57a1.32,1.32,0,0,1-.43-.21l-3.6-2.56a1.4,1.4,0,0,0-1.3-.17l-2.92,1a1.42,1.42,0,0,1-1.09,0l-5.66-2.65A1.38,1.38,0,0,0,163.16,238.23Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M168.6,163.1l.76-3.25a1.73,1.73,0,0,1,1.49-1.27l5.32-.79a2,2,0,0,1,1.21.19l6.55,3.33a.72.72,0,0,1,.26,1.11l-2.63,3.07a.67.67,0,0,0,0,.87l3.73,4.87a.64.64,0,0,1,.14.51l-.71,5.61a.63.63,0,0,1-.12.31l-2.07,3a.92.92,0,0,1-.92.33l-5.67-1.22-.26-.08-.52-.18a1.57,1.57,0,0,1-.1-3l1.06-.46a1.57,1.57,0,0,0,1-1.67,19.57,19.57,0,0,0-1-4.35,9.87,9.87,0,0,1-.63-2.9A1.74,1.74,0,0,0,174,165.7l-4-.67a1.64,1.64,0,0,1-1.4-1.93Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M145.77,152.7l-2.44,1.79a1.5,1.5,0,0,0-.29,2.24l2.33,2.72.12.15,3,4.51a1.81,1.81,0,0,0,.9.68l2.87,1a2,2,0,0,0,1.85-.28l2-1.51a1.71,1.71,0,0,0,.44-.49l2.33-4a1.53,1.53,0,0,0,.2-.75h0A1.87,1.87,0,0,0,156,157.6l-.13.11a2,2,0,0,1-2.63-.05l-5-4.8A2,2,0,0,0,145.77,152.7Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M195.82,145.25,187,151.59a.71.71,0,0,0-.27.82l1.66,4.44a.8.8,0,0,0,.56.48l5,1.32a1,1,0,0,1,.74.79l1.27,9.91a.75.75,0,0,1-.07.44l-3,6.86a.83.83,0,0,0,0,.58l2.46,8.31a1,1,0,0,0,.58.62l2,.84a1.14,1.14,0,0,0,1.37-.4l4.08-6.56a1.09,1.09,0,0,1,.44-.38l6.73-3.06a1.141,1.141,0,0,0,.23-.15l9.88-8.07a1,1,0,0,0,.31-.48l3.52-13.74a1,1,0,0,1,.21-.38l5.45-5.91a.85.85,0,0,0,.17-.92l-.62-1.52a1.09,1.09,0,0,0-1.39-.54l-3,1.12a1.19,1.19,0,0,1-.59.06l-1.87-.3a.92.92,0,0,1-.07-1.83h0a.91.91,0,0,0,.45-1.61l-.67-.54a.809.809,0,0,1-.16-.16l-2.39-3.07a1.11,1.11,0,0,0-.86-.41h-6.77a1.17,1.17,0,0,0-.75.27l-3.83,3.39a.9.9,0,0,0-.29.84l.38,1.81a1,1,0,0,1-1.43,1l-2.15-.77a1,1,0,0,1-.55-.46L203,143.1a1.13,1.13,0,0,0-1.42-.43L196,145.15A.85.85,0,0,0,195.82,145.25Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M179.73,139.09l10.67-2.49a1,1,0,0,1,.42,0l9.5,2.07a.9.9,0,0,1,.36,1.67l-1.4.89h-.05l-13,9.25-5.81,4.2a2,2,0,0,1-1.49.34l-5.73-1a2,2,0,0,0-1.61.43l-1.78,1.54a2,2,0,0,1-2.91-.44l-.78-1.38a1.419,1.419,0,0,1-.08-.18l-.6-1.47a1.58,1.58,0,0,1,1.1-2.09l3.5-1.11a2,2,0,0,1,1.35,0l2.65,1a2,2,0,0,0,1.45,0h.06a1.54,1.54,0,0,0,.69-2.54l-.68-.73a1.48,1.48,0,0,1-.22-1.79l3.22-5.5a1.85,1.85,0,0,1,1.17-.67Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M153.75,145.82l3.89-.91a1.83,1.83,0,0,1,2.28,1.35l.56,3.59a1.6,1.6,0,0,1-1.11,1.72l-3.29,1.23a1.88,1.88,0,0,1-2.48-1.09l-1.15-3.91a1.62,1.62,0,0,1,1.3-1.98Z"
                    fill="#e4e3e3"
                    fillRule="evenodd"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="18.73"
                    cy="18.73"
                    r="18.73"
                    transform="translate(125.29 152.54)"
                    fill="#707272"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M162.72,170.26H125.29s-1.49,10.4,15.23,38.88a4.09,4.09,0,0,0,7,0C164.24,180.67,162.72,170.26,162.72,170.26Z"
                    fill="#707272"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M144,211.73v.11h0a4.64,4.64,0,0,1-4-2.3c-9.78-16.64-13.36-27.17-14.64-33.06a19.419,19.419,0,0,1-.64-4,10,10,0,0,1,0-2.05v-.29a19.28,19.28,0,0,1,38.47.19,9.829,9.829,0,0,1,0,1v.07a19,19,0,0,1-.78,5.41c-1.32,5.89-4.93,16.31-14.53,32.68a4.55,4.55,0,0,1-3.88,2.24ZM125.8,171.1v1.29h0a18.76,18.76,0,0,0,.61,3.82h0c1.26,5.81,4.81,16.2,14.51,32.74a3.54,3.54,0,0,0,3,1.72h0a3.69,3.69,0,0,0,3-1.74c9.55-16.26,13.11-26.6,14.42-32.4h0a18,18,0,0,0,.63-5.12l-.11-.08h0a7.879,7.879,0,0,1,.08-.91H162a18.17,18.17,0,0,0-36.28.19v.55Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="10.82"
                    cy="10.82"
                    r="10.82"
                    transform="translate(128.969 168.758) rotate(-35.78)"
                    fill="#fff"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M144.08,182.63a11.43,11.43,0,1,1,11.42-11.42,11.43,11.43,0,0,1-11.42,11.42Zm0-21.64a10.2,10.2,0,1,1,0,.01Z"
                    fill="#707272"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M133.82,159.94a.18.18,0,0,1-.12-.32,16.83,16.83,0,0,1,10.93-4,.18.18,0,0,1,0,.36,16.43,16.43,0,0,0-10.69,4,.19.19,0,0,1-.12-.04Z"
                    fill="#fff"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M128,172.55a.19.19,0,0,1-.18-.19,16.76,16.76,0,0,1,2.51-8.83.18.18,0,0,1,.25-.06.19.19,0,0,1,.06.25,16.35,16.35,0,0,0-2.46,8.64A.19.19,0,0,1,128,172.55Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="18.73"
                    cy="18.73"
                    r="18.73"
                    transform="translate(227.866 237.5) rotate(-80.78)"
                    fill="#707272"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M268.05,221H230.62s-1.49,10.39,15.23,38.87a4.08,4.08,0,0,0,7,0C269.57,231.41,268.05,221,268.05,221Z"
                    fill="#707272"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M249.34,262.47v.1h0a4.65,4.65,0,0,1-4-2.29c-9.78-16.65-13.36-27.17-14.64-33.06a19,19,0,0,1-.64-4.05,9.9,9.9,0,0,1,0-2v-.3a19.27,19.27,0,0,1,38.46.19,7,7,0,0,1,0,1v.06a19,19,0,0,1-.78,5.42c-1.32,5.89-4.93,16.31-14.53,32.67a4.54,4.54,0,0,1-3.87,2.26Zm-18.21-40.63c0,.28,0,.68.05,1.29h0a18.65,18.65,0,0,0,.61,3.82h0c1.26,5.81,4.81,16.21,14.51,32.74a3.53,3.53,0,0,0,3,1.73h0a3.69,3.69,0,0,0,3-1.74c9.54-16.27,13.11-26.6,14.41-32.4h0a18,18,0,0,0,.63-5.13l-.11-.07h0a7.875,7.875,0,0,1,.08-.91h.06a18.17,18.17,0,0,0-36.28.19v.55Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="10.82"
                    cy="10.82"
                    r="10.82"
                    transform="translate(234.306 219.509) rotate(-35.78)"
                    fill="#fff"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M249.41,233.36a11.42,11.42,0,1,1,11.42-11.42,11.42,11.42,0,0,1-11.42,11.42Zm0-21.63a10.21,10.21,0,1,0,10.21,10.21A10.21,10.21,0,0,0,249.41,211.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M239.15,210.68a.18.18,0,0,1-.12-.32A16.79,16.79,0,0,1,250,206.31a.2.2,0,0,1,.19.19.19.19,0,0,1-.19.18,16.38,16.38,0,0,0-10.69,4,.19.19,0,0,1-.16,0Z"
                    fill="#fff"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M233.36,223.28a.18.18,0,0,1-.18-.18,16.79,16.79,0,0,1,2.51-8.84.18.18,0,0,1,.25,0,.19.19,0,0,1,.06.25,16.35,16.35,0,0,0-2.46,8.64.18.18,0,0,1-.18.13Z"
                    fill="#fff"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M376.3,210.69l16.77,41.35,2.75-.77-17.13-41.35Z"
                    opacity="0.3"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M369.26,156.61s5.12,2.49,6.06,5.35c.75,2.29,6.41,2.59,7,7.1a5.18,5.18,0,0,0,4.33,4.55c5.78.88,14.68,3.88,16.11,13.91,1.08,7.66-2.82,10.56-6.92,11.57a5.81,5.81,0,0,0-4.4,6.7c.59,2.91-.28,6.28-5.33,9-11.31,6-22.61-14.14-22.61-14.14l-2.31-35.11Z"
                    fill="#707272"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M307.72,148.29S330.3,184,357.15,190.91c0,0-5.23,14.9-9.27,16.61,0,0-33-27.57-41.53-54.16Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M415.75,376.76l.74,6a2.48,2.48,0,0,0,2.18,2.18,38.519,38.519,0,0,0,8.05.12,2.13,2.13,0,0,0,1.79-2.76c-.74-2.32-2.09-5.81-4-7.86h-6.68a2.06,2.06,0,0,0-2.08,2.32Z"
                    fill="#636464"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M366.57,362.27c.09,1.51.17,2.89.22,4.13a11.9,11.9,0,0,1-1.77,6.8l-6.56,10.66L375.13,374l.33-2-2.73-3.76.43-5.06Q369.85,362.84,366.57,362.27Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M357.36,385.4h5.32a3.2,3.2,0,0,0,2.54-1.24c1.66-2.16,5.1-6.37,6.74-6.47,2.21-.15,1.93,7.71,1.93,7.71h1.24l1.57-9.77a5.8,5.8,0,0,0-3-6.05s-.51,3.74-3.25,5.4-11.16,7.57-11.16,7.57a7.84,7.84,0,0,0-2.16.06,1.41,1.41,0,0,0,.23,2.79Z"
                    fill="#636464"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M419.18,363a69.8,69.8,0,0,1-2.12-7.7q-3.33,1-6.59,2.1c.63,1.42,1.12,2.61,1.46,3.51a92.472,92.472,0,0,1,4.79,18.32c.07,1.18,1.54,2.31,5.59,2.31,2.09,0,3.12-.83,3.62-1.65a2.37,2.37,0,0,0,.09-2.28C424.74,375,420.68,366.75,419.18,363Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M365.73,174.21,370.37,195c.44,1.83-1.23,1.53-3.09,1.18-3-.57-6.95-1.75-8.25-4.11a2.2,2.2,0,0,1-.24-.79l-2-14.44a2.59,2.59,0,0,1,1.51-2.72l3.85-1.71a2.59,2.59,0,0,1,3.58,1.8Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M356.85,155.22s-4.93,3.35-7.05,11.85,1.32,11.56,4.85,11.37,8.66-1.28,13.1-7.38S363.32,151.14,356.85,155.22Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M363.27,167.63s1.81-12.19-8.31-10.33l-2,2.14s-5-5.58.53-9.8,13.09-3.14,17.3,4.54S376.47,167.25,373,172s-6.18.68-6.18.68,1.61-4.13.27-5.9-3.07,1-3.07,1Z"
                    fill="#707272"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M363.86,169.79s.89-6.27,4.09-4.48-1.15,5.86-2.9,7.24Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M307.87,155.64c-.07.74,2.67,1.25,3.55-1.9-.24-1.36-.67-7.33-1.72-8.26-5.56-4.94-15.5-10.5-15.5-10.5a2,2,0,0,0,.35,2.81l5,3.35a20.129,20.129,0,0,0-1.36,5.18,5.78,5.78,0,0,0,1.47,4.05,48,48,0,0,0,3.51,3.69A5.73,5.73,0,0,0,307.87,155.64Z"
                    fill="#d3d3d3"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M305.18,153.21l.76-.32c-.1-.24-2.48-6-3.63-7.23a1.71,1.71,0,0,1-.63-1.16.82.82,0,0,1,.25-.51l4,2.15,1.77,2.77.7-.44-1.89-2.95-4.7-2.52-.21.18a1.75,1.75,0,0,0-.75,1.27,2.41,2.41,0,0,0,.85,1.78C302.58,147.14,304.51,151.57,305.18,153.21Z"
                    fill="#707272"
                    opacity="0.5"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M352.54,242.65,351,251.12a408.79,408.79,0,0,0,11.32,61.78c1.78,17.81,3.06,34.94,3.77,51.27,1.61.63,3.46,1.13,8.14.24,1.68-23.23,6-45.59-2.15-52.45l-1.92-42.88-6.71-25.63Z"
                    fill="#636464"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M363.25,242.5,369,272.91c6.75,16.56,13.47,33,18.69,39.77,7.68,11,15.34,29.17,23,48.62a9.43,9.43,0,0,0,7.91-2.4c-2.87-22.69-8.45-41.76-21.56-50.78-2.71-31.37-6.7-60.66-24.67-67.4Z"
                    fill="#636464"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M372.35,240.72c-5.7-24.16,8.74-37.82,8.74-37.82-9.11-8.75-25.72-12.73-25.72-12.73s-15.84,11.58-14,20.65c1.1,5.31,11.13,31.83,11.13,31.83a22.07,22.07,0,0,0,19.85-1.93Z"
                    fill="#707272"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M373,253.84l19.68-6.76a2.11,2.11,0,0,1,2.74,1.5l4,16.49a2.11,2.11,0,0,1-1.35,2.5l-19.48,7a2.12,2.12,0,0,1-2.76-1.48l-4.22-16.69a2.11,2.11,0,0,1,1.39-2.56Z"
                    fill="#707272"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M372.64,260.35l15,2.74,8.92-9.66-1.19-4.85a2.11,2.11,0,0,0-2.74-1.5L373,253.84a2.11,2.11,0,0,0-1.36,2.52Z"
                    fill="#636464"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M373.78,258.26c-3.26-25.64-8.46-54.54-.24-61l3.72,2.13c-9.62,3.47-5.59,30.55-1.32,58.34Z"
                    opacity="0.3"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M381.09,202.9s32.35,23.14,4.14,47.47a7.41,7.41,0,0,1-3.19,1.85c-1.07.32-4.23,2.71-5.84,4a1.09,1.09,0,0,1-1.6-.29,1.49,1.49,0,0,1-.09-1.43l4-8.47a3.09,3.09,0,0,1,4-.18,1.52,1.52,0,0,0,2.31-.52c2.18-4.44,6.3-17.51-10.56-32.27a1.83,1.83,0,0,1-.4-2.22C375.06,208.52,377.77,204,381.09,202.9Z"
                    fill="#d3d3d3"
                />
            </g>
        </SVGIcon>
    );
}
